

import { Component, OnInit, inject, input, signal, ChangeDetectionStrategy } from '@angular/core';
import { serverTimestamp } from '@angular/fire/firestore';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { LoadingButtonComponent, TimestampPipe } from '@scandium-oy/ngx-scandium';
import { take } from 'rxjs/operators';
import { AppCommonModule } from 'src/app/common.module';
import { SegmentListComponent } from 'src/app/components/segment-list/segment-list.component';
import { Note } from 'src/app/models/note.model';
import { Site } from 'src/app/models/site.model';
import { AiService } from 'src/app/services/ai.service';
import { ContractorsService } from 'src/app/services/contractors.service';
import { NotesService } from 'src/app/services/notes.service';
import { QuillService } from 'src/app/services/quill.service';
import { UserSessionService } from 'src/app/services/user-session.service';
import { ModalShellComponent } from 'src/app/ui/modal-shell/modal-shell.component';
import { ReportNoteComponent } from '../component/note.component';

@Component({
  selector: 'app-new-note-dialog',
  templateUrl: './new-note.dialog.html',
  styleUrls: ['./new-note.dialog.scss'],
  imports: [
    AppCommonModule,
    ModalShellComponent,
    LoadingButtonComponent,
    SegmentListComponent,
    ReportNoteComponent,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [TimestampPipe, QuillService],
})
export class NewNoteDialogComponent implements OnInit {
  private aiService = inject(AiService);
  private notesService = inject(NotesService);
  private quillService = inject(QuillService);

  formGroup: FormGroup;
  loading = signal(false);
  viewSegment = signal('ai');

  viewSegmentButtons = [
    {
      value: 'ai',
      name: 'notes.ai',
      show: true,
    },
    {
      value: 'text',
      name: 'notes.plain',
      show: true,
    },
  ];

  noteText = signal<string>('');

  item = input<Note>(null);
  site = input<Site>(null);

  constructor(
    private contractorsService: ContractorsService,
    private formBuilder: FormBuilder,
    private _modal: ModalController,
    private usersService: UserSessionService,
  ) {
  }

  ngOnInit(): void {
    const item = this.item();
    this.formGroup = this.formBuilder.group({
      guid: [item?.guid ?? null],
      text: [item?.text ?? '', Validators.required],
    });
    if (item != null) {
      this.noteText.set(item.text);
      this.viewSegment.set('text');
    }
  }

  onAi() {
    const originalText = this.formGroup.get('text').value;
    this.loading.set(true);
    this.aiService.doNote(originalText).pipe(
      take(1),
    ).subscribe((text) => {
      this.noteText.set(text);
      this.loading.set(false);
      this.viewSegment.set('text');
    });
  }

  save() {
    const user = this.usersService.currentUserS();
    const text = this.quillService.getHtml();
    const item = this.formGroup.value;
    item.text = text;
    if (item.guid) {
      return this.dismiss(item);
    }
    item.date = serverTimestamp();
    item.username = user.displayName;
    item.user = user.guid;
    item.contractor = this.contractorsService.contractorS()?.guid ?? null;
    this.dismiss(item);
  }

  print() {
    const item = this.item();
    if (item == null) {
      return;
    }
    item.text = this.quillService.getHtml();
    this.notesService.print(item);
  }

  dismiss(item?: Note) {
    this._modal.dismiss(item);
  }
}
